/* Tabs — controlled tab strip rendering the mockup `.tabs`/`.tab` markup so the
   scoped underline-animation CSS applies. tabs: [{id, label, pill?}]. */
import React from 'react'
import PropTypes from 'prop-types'
import {cx} from '../components'

export default function Tabs({tabs, value, onChange}) {
  return (
    <div className='tabs' role='tablist'>
      {tabs.map((t) => (
        <button
          key={t.id}
          type='button'
          role='tab'
          aria-selected={value === t.id}
          className={cx('tab', value === t.id && 'active')}
          onClick={() => onChange(t.id)}
        >
          {t.label}
          {t.pill != null ? <span className='pill'>{t.pill}</span> : null}
        </button>
      ))}
    </div>
  )
}

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
}
